<router-outlet></router-outlet>

<div [innerHTML]="skeleton$ | async" [@slideInOut]="isLoading ? 'in' : 'out'">
</div>
